import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { RequestBoxSendService } from '../requestBoxSend/services/requestBoxSend.service';
import { ProductRoadmapService } from '../productRoadmap/services/productRoadmap.service';
import { RequestBoxService } from './services/requestBox.service';
import { environment } from '../../../../../environments/environment';
import { Router } from '@angular/router';
import { UploadService } from 'app/common/services/Upload.service';
import { TranslateService } from '@ngx-translate/core';

declare function baseTracking(appId);

declare function enterScreenView(screenName: any, contentType: any, referrer: any);

declare function visibleContent(regionName: any, contentName: any, index: any);

declare function clickTracking(regionName: any, contentName: any, target: any, payload: any);

declare function alertMsg(alertType: any, alertMessage: any);

declare function searchEvent(keywords: any, params: any, order: any, sort: any)

declare var $: any;

@Component({
  selector: 'app-requestBox',
  templateUrl: './requestBox.component.html',
  styleUrls: ['./requestBox.component.css'],
  providers: [RequestBoxSendService, ProductRoadmapService, RequestBoxService],
})
export class RequestBoxComponent implements OnInit {
  form = this.fb.group({});
  page_title: string;
  // isDistribution: Boolean = false;
  // isList: Boolean = true;
  stasitic: object = {
    total_product: 1000,
    total_show: 20000,
  };
  lotem: string;

  data = [];
  item_active: any;
  pageIndex = 1;
  page_size = 10;
  totalPage: number;
  item_detail: any = {
    id: 1,
    name: 'IC-000001',
  };
  statistic;
  // supplier = [];
  query;
  loading_left = false;
  total_data: 0;
  stampSerialDetail;
  public area: Array<any> = [];
  reason = '';
  bundleType;
  @ViewChild('returnStampBox1') returnStampBox1: ModalDirective;
  @ViewChild('returnBox') returnBox: ModalDirective;

  cancelReturnBoxImages: any = [];

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    public addressService: EvsAddressService,
    public requestBoxSendService: RequestBoxSendService,
    public requestBoxService: RequestBoxService,
    public productRoadmapService: ProductRoadmapService,
    public router: Router,
    private upload: UploadService,
    private translate: TranslateService,
  ) {
  }

  ngOnInit() {
    this.page_title = this.translate.instant('YEU_CAU_TRA_HANG_TU_DAI_LY');
    baseTracking(environment.appIdTracking);
    enterScreenView('qcheck_return_manage', 'others', '');
    const agencyData = JSON.parse(localStorage.getItem('agencyId'));
    if (agencyData) {
      const newOption = new Option(agencyData.name, agencyData.id, false, false);
      $('#distributionAgent').append(newOption).trigger('change');
      $('#classify').val('0').trigger('change');
      localStorage.removeItem('agencyId');
    }
    this.getArea();
    this.initSelect2();
    this.translate.onLangChange.subscribe(() => {
      this.page_title = this.translate.instant('YEU_CAU_TRA_HANG_TU_DAI_LY');
      this.initSelect2();
    });
    this.statisticList();
    this.fetch();
  }

  private initSelect2() {
    this.translate.get([
      'KHU_VUC',
      'TRANG_THAI',
      'LOAI_TEM',
      'DAI_LY_PHAN_PHOI',
    ]).subscribe(t => {
      ['#area', '#statusSearch', '#typeTemp', '#distributionAgent'].forEach(id => {
        if ($(id).data('select2')) { $(id).select2('destroy'); }
      });
      $('#area').select2({ placeholder: t['KHU_VUC'], allowClear: true, width: '140px' });
      $('#statusSearch').select2({ placeholder: t['TRANG_THAI'], allowClear: true, width: '140px' });
      $('#typeTemp').select2({ placeholder: t['LOAI_TEM'], allowClear: true, width: '140px' });
      $('#distributionAgent').select2({
        placeholder: t['DAI_LY_PHAN_PHOI'],
        allowClear: true,
        width: '170px',
        ajax: {
          delay: 500,
          url: `${environment.qrcode_url}/agencies`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem('Access-Token')}`,
            'Content-Type': 'application/json',
          },
          dataType: 'json',
          data: function (params) {
            if (params.term) {
              return { name: params.term, offset: 0, limit: 50 };
            }
            return { offset: 0, limit: 50 };
          },
          processResults: (data) => {
            return {
              results: data.data.items.map((item) => ({ text: item.name, id: item.id })),
            };
          },
        },
      });
    });
  }


  statisticList() {
    this.requestBoxService.requestBoxStatistic().subscribe((res) => {
      this.statistic = res.data;
    });
  }

  fetch() {
    const timePicker = $('.timePicker');
    let distributionAgent = '';
    if (
      $('#distributionAgent').val() === null ||
      isNaN($('#distributionAgent').val())
    ) {
      distributionAgent = '';
    } else {
      distributionAgent = $('#distributionAgent').val();
    }

    this.query = {
      agencyId: distributionAgent,
      proviceId: $('#area').val(),
      requestStatus: $('#statusSearch').val(),
      fromDate: timePicker.val().split('-')[0]
        ? timePicker.val().split('-')[0].trim().split('/').join('-')
        : '',
      toDate: timePicker.val().split('-')[1]
        ? timePicker.val().split('-')[1].trim().split('/').join('-')
        : '',
      prefix: $('.prefix').val(),
      idStart: $('.serialStart').val(),
      idEnd: $('.serialEnd').val(),
      type: $('#typeTemp').val(),
      code: $('.code').val(),
      page: this.pageIndex,
      pageSize: this.page_size,
    };

    this.requestBoxService.requestBoxList(this.query).subscribe(
      (res) => {
        if (res.code === 1) {
          if (
            res.data.items == null ||
            (res.data.item && res.data.item.length == 0)
          ) {
            this.total_data = 0;
            this.loading_left = false;
            this.data = [];
            this.toastr.warning(this.translate.instant('KHONG_CO_DU_LIEU'), this.translate.instant('THONG_BAO'), {
              timeOut: 4000,
              positionClass: 'toast-top-right',
            });
            return;
          }

          this.total_data = res.data.totalElement;
          this.data = res.data.items.map((item: any) => {
            let tmpItem = item;
            tmpItem.serialStart = this.formatSerial(item.idStart, item.prefix);
            tmpItem.serialEnd = this.formatSerial(item.idEnd, item.prefix);
            return tmpItem;
          });
          if (this.data !== null && this.data.length > 0) {
            this.data.map((item, i) => {
              if (i === 0) {
                this.viewDetail(item, i);
              }
            });
          }
          this.loading_left = false;
          return;
        }
        this.total_data = 0;
        this.loading_left = false;
        this.data = [];
        this.toastr.warning(res.message, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      },
      (err) => {
        this.total_data = 0;
        this.loading_left = false;
        this.data = [];
        this.toastr.warning(err.message, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      }
    );
  }

  getArea() {
    this.addressService.getCities().subscribe((res) => {
      const citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.area = citiesList;
    });
  }

  search() {
    this.pageIndex = 1;
    this.loading_left = true;
    this.fetch();
  }

  reset() {
    localStorage.removeItem('agencyId');
    $('.prefix').val('').trigger('change');
    $('.code').val('').trigger('change');
    $('.serialStart').val('').trigger('change');
    $('.serialEnd').val('').trigger('change');
    $('#area').val(null).trigger('change');
    $('#distributionAgent').val(null).trigger('change');
    $('#statusSearch').val(null).trigger('change');
    $('.timePicker').val(null).trigger('change');
    $('#typeTemp').val(null).trigger('change');
    this.pageIndex = 1;
    this.fetch();
  }

  viewDetail(item, i) {
    this.bundleType = item.bundleType;
    this.item_active = i;
    const query = {
      type: this.bundleType,
    };
    // @ts-ignore
    this.requestBoxService.requestBoxDetail(query, item.id).subscribe((res) => {
      this.item_detail = res.data;
      this.item_detail.serialStart = this.formatSerial(
        res.data.idStart,
        res.data.prefix
      );
      this.item_detail.serialEnd = this.formatSerial(
        res.data.idEnd,
        res.data.prefix
      );
    });
    this.requestBoxSendService
      .stampSerial(item.prefix + '-' + item.idStart)
      .subscribe((res) => {
        if (res.data) {
          const stampSerialDetail = { ...res.data };

          const arr = [];
          res.data.service.map((val) => {
            if (val === 'CG') {
              arr.push(' Chống hàng giả');
            }
            if (val === 'BH') {
              arr.push(' Bảo hành');
            }
            if (val === 'TH') {
              arr.push(' Tràn hàng');
            }
            if (val === 'DD') {
              arr.push(' Định danh');
            }
          });
          stampSerialDetail.service = arr;
          this.stampSerialDetail = stampSerialDetail;
        }
      });
  }

  viewDetailTracking() {
    console.log('sssss', this.item_detail.id);
    clickTracking('qcheck_return_manage', 'stamp_return', 'qcheck_return_detail', this.item_detail.id);
    visibleContent('qcheck_return_detail', 'return_info', '')
  }

  // load page danh sach lịch sử đóng thùng
  prePageList() {
    if (this.pageIndex > 1) {
      this.pageIndex = this.pageIndex - 1;
      this.loading_left = true;

      this.fetch();
    }
  }

  lastPageList() {
    // console.log('res.items', this.pageIndex * this.page_size, this.total_data )

    if (this.pageIndex * this.page_size < this.total_data) {
      this.pageIndex = this.pageIndex + 1;
      this.loading_left = true;

      this.fetch();
    }
  }

  inputPageList(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndex) {
      this.pageIndex = page;
      this.loading_left = true;

      this.fetch();
    }
  }

  trackingReturnStampBox1() {
    clickTracking('qcheck_return_detail', 'return_accept', 'form_accept', '');
    visibleContent('qcheck_return_detail', 'return_accept', '')
  }

  handleReturnStampBox() {
    clickTracking('form_accept', 'accept_confirm', 'qcheck_return_detail', '');
    const body = {
      type: this.bundleType,
      action: 1,
    };
    this.requestBoxService
      .requestBoxActive(body, this.item_detail.id)
      .subscribe(
        (res) => {
          if (res.code === 1) {
            this.toastr.success(this.translate.instant('CHAP_NHAN_TRA_HANG_THANH_CONG'), this.translate.instant('THANH_CONG'));
            this.returnStampBox1.hide();
            this.fetch();
            return;
          }
          this.toastr.error(`${res.message}`, this.translate.instant('THAT_BAI'));
        },
        (error) => {
          this.toastr.error(`${error.message}`, this.translate.instant('THAT_BAI'));
        }
      );
  }


  trackingReturnStampBox() {
    clickTracking('qcheck_return_detail', 'return_reject', 'form_reject', '');
    visibleContent('qcheck_return_detail', 'form_reject', '')
  }

  handleReturnBox() {
    clickTracking('form_reject', 'reject_confirm', 'qcheck_return_detail', '');
    if (this.reason.trim().length === 0) {
      this.toastr.warning(this.translate.instant('CHUA_NHAP_LY_DO_TU_CHOI'), this.translate.instant('THONG_BAO'), {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }
    if (this.reason.trim().length > 255) {
      this.toastr.warning(this.translate.instant('NHAP_QUA_255_KY_TU'), this.translate.instant('THONG_BAO'), {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }
    const body: any = {
      type: this.bundleType,
      action: 2,
      cancelReason: this.reason,
      document: {
        items:
          this.cancelReturnBoxImages && this.cancelReturnBoxImages.length
            ? this.cancelReturnBoxImages
            : null,
      },
    };
    this.requestBoxService
      .requestBoxActive(body, this.item_detail.id)
      .subscribe(
        (res) => {
          if (res.code === 1) {
            this.toastr.success(this.translate.instant('TU_CHOI_THANH_CONG'), this.translate.instant('THANH_CONG'));
            this.reason = '';
            this.returnBox.hide();
            this.fetch();
            return;
          }
          this.toastr.error(`${res.message}`, this.translate.instant('THAT_BAI'));
        },
        (error) => {
          this.toastr.error(`${error.message}`, this.translate.instant('THAT_BAI'));
        }
      );
  }

  // search serial
  searchInfoSerial(code: string) {
    this.router.navigate(['/find-stamp'], { queryParams: { code } });
  }

  formatSerial(id: any, prefix: string) {
    let serial_f: string = '';
    id = id.toString();
    if (id && prefix) {
      let pad = '000000';
      let serial = pad.substring(0, 6 - id.length) + id;
      serial_f = prefix + '-' + serial;
    }
    return serial_f;
  }

  // handle images when upload

  tusUploadCancelReturnBoxImages = (item) => {
    const numberImages = item.target.files.length;
    for (const image of item.target.files) {
      const fileData = new FormData();
      // @ts-ignore
      fileData.append('file', image);
      return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
        const res = JSON.parse(response._body)
        if (res.status === 200) {
          const image2 = {
            id: res.data.fileId,
            url: res.data.url,
          };
          this.cancelReturnBoxImages.push(image2);

        }
      });


    }
  };

  // delete image upload
  deleteImage(index: number) {
    this.cancelReturnBoxImages.splice(index, 1);
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/requestBox/requestBox.component.ts